import { Content } from 'pages/Content';

export const TipsAndTrainings = () => {
  return (
    <Content
      title='Dicas e treinamentos'
      document='dicas_e_treinamentos'
      description='Conteúdos para te ajudar a vender cada vez mais.'
      showHeaderCarrossel
    />
  );
};
